/**
 * Consent configuration. Everything consent-related lives in this folder so it
 * can be copied to main-new-ui (MR !3115) as-is.
 *
 * `templates/_consent_head.html` (inline, runs before any bundle) sets
 * window.TUNE_CONSENT_CONFIG; values there win over these defaults. Keep the
 * IDs / names in sync if you change them.
 */
/**
 * Bump to re-prompt everyone (e.g. new category or tracker). 2 (Nov 5, 2026): final copy +
 * Adobe Fonts moved from Marketing to Strictly necessary, so consents stored under v1 re-prompt.
 */
export const CONSENT_VERSION = 2
/** Final policy version (Cookie Consent Spec §4, DesignBot, Nov 5, 2026). */
export const POLICY_VERSION = '2026-11-05'
export const STORAGE_KEY = 'tune_consent'
export const COOKIE_NAME = 'tune_consent'
export const PENDING_KEY = 'tune_consent_pending'
/** Re-consent interval (spec §4 reconsent_months: 12, Andrew-accepted). */
export const RECONSENT_MONTHS = 12
/** RECONSENT_MONTHS as days for the stored-consent expiry check. */
export const CONSENT_MAX_AGE_DAYS = 365
export const GA4_ID = 'G-6689026RCH'
export const GTM_ID = 'GTM-W5LBRNP4'
/** BackendBot cookie-consent API (MR !3123, privacy/urls.py `^consent/?$`). null disables posting. */
export const CONSENT_API_URL: string | null = '/api/v1/privacy/consent'
/** spec §4 privacy_policy_url */
export const PRIVACY_URL = 'https://tune.fm/privacy-policy/'
/** !3123 per-purpose consent for signed-in users (was `/consent`). Not used by the cookie banner. */
export const CONSENT_PURPOSES_URL = '/api/v1/privacy/consent/purposes'
/** window event fired on every saved choice (bridges tune-consent.js and the SPA bundle). */
export const CONSENT_EVENT = 'tune:consent-change'

export interface ConsentRuntimeConfig {
  version: number
  policyVersion: string
  storageKey: string
  cookieName: string
  gaId: string
  gtmId: string
  /** false on dev/local (Django SERVER flag off): never inject Google tags. */
  enableTags: boolean
  apiUrl: string | null
  maxAgeDays: number
  privacyUrl: string
}

export function getConfig(): ConsentRuntimeConfig {
  const w: any = typeof window !== 'undefined' ? window : {}
  const o = w.TUNE_CONSENT_CONFIG || {}
  return {
    version: o.version ?? CONSENT_VERSION,
    policyVersion: o.policyVersion ?? POLICY_VERSION,
    storageKey: o.storageKey ?? STORAGE_KEY,
    cookieName: o.cookieName ?? COOKIE_NAME,
    gaId: o.gaId ?? GA4_ID,
    gtmId: o.gtmId ?? GTM_ID,
    enableTags: o.enableTags ?? false,
    apiUrl: o.apiUrl === undefined ? CONSENT_API_URL : o.apiUrl,
    maxAgeDays: o.maxAgeDays ?? CONSENT_MAX_AGE_DAYS,
    privacyUrl: o.privacyUrl ?? PRIVACY_URL,
  }
}
